import { request2 } from '../utils/request';

export async function getOutInfo(orderid) {
  return await request2(`outapi/getorder?orderid=${orderid}`, 'get');
}
export async function getCategory(category, shop) {
  return await request(`data?category=${category}&shop=${shop}`, 'get');
}